import React from 'react';
import CrudPage from '../../components/CrudPage';
import { cashWalletApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'cashWalletId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Balance', field: 'balance', render: (v) => v ? `£${v.toLocaleString()}` : '£0' },
  { header: 'Currency', field: 'currency' },
  { header: 'Updated', field: 'updatedAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'balance', label: 'Balance', type: 'number', required: true },
  { name: 'currency', label: 'Currency', type: 'text', defaultValue: 'GBP' },
];

const CashWalletPage = () => (
  <CrudPage
    title="Cash Wallets"
    subtitle="Manage investor wallets (create only - use Adjust API for balance changes)"
    api={cashWalletApi}
    columns={columns}
    formFields={formFields}
    idField="cashWalletId"
    disableEdit={true}
    disableDelete={true}
  />
);

export default CashWalletPage;
